import { events as notifyEventBus } from './scripts/events'

export class Notifier {
  constructor(emitter) {
    this.emitter = emitter || notifyEventBus
  }

  // открытие уведомлений
  open(params) {
    if (typeof params === 'string') {
      this.emitter.publish('component/notifications/add', { text: params })
    }

    if (typeof params === 'object') {
      this.emitter.publish('component/notifications/add', params)
    }
  }

  // закрытие уведомлений по id
  close(id) {
    this.emitter.publish('component/notifications/close', id)
  }

  closeAll() {
    this.emitter.publish('component/notifications/closeAll')
  }

  // методы для работы с нотификациями
  get notifications() {
    return {
      open: this.open.bind(this),
      close: this.close.bind(this),
      closeAll: this.closeAll.bind(this),
    }
  }
}
